var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('customer-details',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var id = ref.id;
return [(id!==0)?_c('div',{staticClass:"mx-5 my-5"},[_c('v-form',{ref:"form"},[_c('v-card',{staticClass:"px-10 py-10"},[_c('customer-credit-card',{attrs:{"clientId":id}})],1)],1)],1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }